export default {
  "CC_R10MM_ANN_EXT_2030S_RCP26_CHANGE_MME_GLOBAL": "R10mm (%)",
  "CC_TSTD_JJA_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_R10MM_ANN_EXT_2050S_RCP45_VALUE_MMS_GLOBAL": "R10mm (d)",
  "CC_TSTD_DJF_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP26_CHANGE_MMS_GLOBAL": "rx5day (%)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_TXX_ANN_EXT_2000S_S0_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_TMEAN_DJF_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TN10P_ANN_EXT_2050S_RCP26_CHANGE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP26_VALUE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP26_CHANGE_MMS_GLOBAL": "rx1day (%)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP26_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TX90P_ANN_EXT_2050S_RCP45_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_JJA_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_ANN_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_DJF_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TX90P_ANN_EXT_2030S_RCP45_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_RX5DAY_ANN_EXT_2000_S0_VALUE_MMS_GLOBAL": "rx5day (mm)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TSTD_DJF_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_TXX_ANN_EXT_2030S_RCP85_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TN10P_ANN_EXT_2030S_RCP26_VALUE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_ANN_VAR_2000S_S0_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_TSTD_JJA_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_VAR_2000_S0_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP26_VALUE_MME_GLOBAL": "RX5D (mm/d)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP85_VALUE_MME_GLOBAL": "RX1D (mm/d)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TSTD_JJA_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP26_VALUE_MMS_GLOBAL": "rx1day(mm/day)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TX90P_ANN_EXT_2050S_RCP26_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP85_CHANGE_MMS_GLOBAL": "rx5day (%)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_DJF_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TX90P_ANN_EXT_2030S_RCP26_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_R10MM_ANN_EXT_2030S_RCP85_VALUE_MME_GLOBAL": "R10mm (d)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_TMEAN_DJF_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_ANN_VAR_2000S_S0_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_DJF_MEAN_2000S_S0_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_R10MM_ANN_EXT_2000_S0_VALUE_MME_GLOBAL": "R10mm (d)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP45_CHANGE_MMS_GLOBAL": "rx5day (%)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_JJA_MEAN_2000S_S0_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP85_CHANGE_MMS_GLOBAL": "rx1day (%)",
  "CC_TXX_ANN_EXT_2030S_RCP26_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TN10P_ANN_EXT_2050S_RCP85_CHANGE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_DJF_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_DJF_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_ANN_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_JJA_MEAN_2000S_S0_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2000S_S0_VALUE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP85_CHANGE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_TXX_ANN_EXT_2050S_RCP85_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP45_CHANGE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_TXX_ANN_EXT_2050S_RCP26_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TX90P_ANN_EXT_2030S_RCP26_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TSTD_ANN_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TSTD_ANN_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TN10P_ANN_EXT_2030S_RCP85_VALUE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TSTD_DJF_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TX90P_ANN_EXT_2050S_RCP45_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TX90P_ANN_EXT_2050S_RCP85_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP85_VALUE_MMS_GLOBAL": "rx5day(mm/d)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_DJF_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TN10P_ANN_EXT_2030S_RCP26_CHANGE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TN10P_ANN_EXT_2030S_RCP45_VALUE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP26_CHANGE_MME_GLOBAL": "rx1day (%)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP26_VALUE_MMS_GLOBAL": "rx5day(mm/day)",
  "CC_TSTD_ANN_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_SFCWIND_ANN_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_ANN_MEAN_2000S_S0_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_SFCWIND_DJF_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TN10P_ANN_EXT_2050S_RCP26_VALUE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_ANN_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP45_CHANGE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_ANN_VAR_2000_S0_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP45_VALUE_MMS_GLOBAL": "rx5day(mm)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_DJF_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TXX_ANN_EXT_2050S_RCP45_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_DJF_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TSTD_ANN_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP26_CHANGE_MME_GLOBAL": "rx5day (%)",
  "CC_TSTD_DJF_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TX90P_ANN_EXT_2000S_S0_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TMEAN_ANN_MEAN_2000S_S0_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TX90P_ANN_EXT_2050S_RCP85_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP26_VALUE_MME_GLOBAL": "RX1D (mm/d)",
  "CC_R10MM_ANN_EXT_2050S_RCP26_CHANGE_MME_GLOBAL": "R10mm (%)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP26_CHANGE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_JJA_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_TSTD_JJA_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TSTD_ANN_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TSTD_ANN_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_R10MM_ANN_EXT_2050S_RCP85_CHANGE_MME_GLOBAL": "R10mm (%)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_RX1DAY_ANN_EXT_2030S_RCP26_CHANGE_MMS_GLOBAL": "rx1day (%)",
  "CC_TXX_ANN_EXT_2050S_RCP85_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_R10MM_ANN_EXT_2030S_RCP26_VALUE_MME_GLOBAL": "R10mm (d)",
  "CC_TSTD_JJA_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_VAR_2000_S0_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TSTD_ANN_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TXX_ANN_EXT_2030S_RCP45_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TSTD_DJF_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_ANN_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TSTD_JJA_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TSTD_ANN_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP45_CHANGE_MMS_GLOBAL": "rx1day (%)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TX90P_ANN_EXT_2030S_RCP45_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_JJA_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP45_VALUE_MMS_GLOBAL": "rx1day(mm)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP45_VALUE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_RX1DAY_ANN_EXT_2050S_RCP45_VALUE_MME_GLOBAL": "RX1D (mm/d)",
  "CC_TSTD_DJF_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP85_CHANGE_MME_GLOBAL": "rx5day (%)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_MEAN_2000S_S0_VALUE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_JJA_VAR_2000S_S0_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP85_CHANGE_MMS_GLOBAL": "rx1day (%)",
  "CC_TSTD_DJF_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_TX90P_ANN_EXT_2030S_RCP26_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_DJF_MEAN_2000_S0_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP45_CHANGE_MMS_GLOBAL": "rx1day (%)",
  "CC_PRCPTOT_ANN_MEAN_2000_S0_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_R10MM_ANN_EXT_2030S_RCP45_VALUE_MME_GLOBAL": "R10mm (d)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP45_CHANGE_MME_GLOBAL": "rx5day (%)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_JJA_MEAN_2000S_S0_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TN10P_ANN_EXT_2030S_RCP85_CHANGE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP85_VALUE_MME_GLOBAL": "RX5D (mm/d)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TSTD_DJF_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_R10MM_ANN_EXT_2050S_RCP26_VALUE_MMS_GLOBAL": "R10mm (d)",
  "CC_TSTD_DJF_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_MEAN_2000_S0_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP85_VALUE_MME_GLOBAL": "RX1D (mm/d)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TSTD_JJA_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_DJF_VAR_2000_S0_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TSTD_JJA_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_R10MM_ANN_EXT_2050S_RCP45_CHANGE_MME_GLOBAL": "R10mm (%)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP85_VALUE_MMS_GLOBAL": "rx1day(mm/d)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TN10P_ANN_EXT_2050S_RCP85_VALUE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TSTD_DJF_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TN10P_ANN_EXT_2030S_RCP45_CHANGE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_R10MM_ANN_EXT_2030S_RCP85_VALUE_MMS_GLOBAL": "R10mm (d)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TXX_ANN_EXT_2050S_RCP26_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_R10MM_ANN_EXT_2030S_RCP85_CHANGE_MME_GLOBAL": "R10mm (%)",
  "CC_TSTD_JJA_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_TX90P_ANN_EXT_2050S_RCP26_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TN10P_ANN_EXT_2000S_S0_VALUE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP85_CHANGE_MME_GLOBAL": "rx5day (%)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_ANN_MEAN_2000S_S0_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_R10MM_ANN_EXT_2030S_RCP45_CHANGE_MME_GLOBAL": "R10mm (%)",
  "CC_TN10P_ANN_EXT_2050S_RCP45_CHANGE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP45_CHANGE_MME_GLOBAL": "rx5day (%)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TXX_ANN_EXT_2030S_RCP26_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TSTD_JJA_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_TN10P_ANN_EXT_2050S_RCP85_CHANGE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_ANN_VAR_2000S_S0_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_DJF_VAR_2000S_S0_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP26_CHANGE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TSTD_ANN_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TX90P_ANN_EXT_2050S_RCP26_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_JJA_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TXX_ANN_EXT_2000S_S0_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TSTD_ANN_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TSTD_JJA_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_R10MM_ANN_EXT_2050S_RCP45_VALUE_MME_GLOBAL": "R10mm (d)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TSTD_ANN_VAR_2000S_S0_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_ANN_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_JJA_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP26_CHANGE_MME_GLOBAL": "rx5day (%)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_RX5DAY_ANN_EXT_2000_S0_VALUE_MME_GLOBAL": "RX5D (mm/d)",
  "CC_TSTD_DJF_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_DJF_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_TXX_ANN_EXT_2030S_RCP85_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TXX_ANN_EXT_2050S_RCP45_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TX90P_ANN_EXT_2030S_RCP45_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_R10MM_ANN_EXT_2050S_RCP45_CHANGE_MMS_GLOBAL": "R10mm (%)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TXX_ANN_EXT_2030S_RCP85_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TSTD_ANN_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TN10P_ANN_EXT_2050S_RCP26_VALUE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TSTD_DJF_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TX90P_ANN_EXT_2030S_RCP85_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TX90P_ANN_EXT_2050S_RCP45_CHANGE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TN10P_ANN_EXT_2050S_RCP26_CHANGE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_R10MM_ANN_EXT_2030S_RCP85_CHANGE_MMS_GLOBAL": "R10mm (%)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP26_CHANGE_MME_GLOBAL": "rx1day (%)",
  "CC_TN10P_ANN_EXT_2030S_RCP45_VALUE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_JJA_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_TSTD_ANN_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TSTD_DJF_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_TSTD_ANN_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TSTD_JJA_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_R10MM_ANN_EXT_2050S_RCP85_VALUE_MME_GLOBAL": "R10mm (d)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TXX_ANN_EXT_2050S_RCP45_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_JJA_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_DJF_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP45_VALUE_MME_GLOBAL": "RX5D (mm/d)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_SFCWIND_DJF_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TX90P_ANN_EXT_2030S_RCP26_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TSTD_DJF_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TX90P_ANN_EXT_2030S_RCP85_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TXX_ANN_EXT_2050S_RCP26_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TSTD_DJF_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_RX1DAY_ANN_EXT_2000_S0_VALUE_MME_GLOBAL": "RX1D (mm/d)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP85_VALUE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP85_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2000S_S0_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TXX_ANN_EXT_2050S_RCP85_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_JJA_VAR_2000S_S0_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP26_VALUE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TSTD_ANN_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP26_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_JJA_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_ANN_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP45_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_ANN_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_RX5DAY_ANN_EXT_2030S_RCP26_VALUE_MMS_GLOBAL": "rx5day (mm/day)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TSTD_ANN_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_TXX_ANN_EXT_2030S_RCP45_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TSTD_ANN_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "Temperature (℃）",
  "CC_TN10P_ANN_EXT_2030S_RCP26_VALUE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_PRCPTOT_JJA_VAR_2000_S0_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TSTD_DJF_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2000_S0_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_ANN_MEAN_2000_S0_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TN10P_ANN_EXT_2050S_RCP45_VALUE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_TMEAN_DJF_MEAN_2000S_S0_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_DJF_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_R10MM_ANN_EXT_2000_S0_VALUE_MMS_GLOBAL": "R10mm (d)",
  "CC_SFCWIND_JJA_MEAN_2000S_S0_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP45_VALUE_MMS_GLOBAL": "rx5day(mm)",
  "CC_TXX_ANN_EXT_2030S_RCP26_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP45_VALUE_MME_GLOBAL": "RX5D (mm/d)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TX90P_ANN_EXT_2030S_RCP45_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP85_VALUE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_PRCPTOT_JJA_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP26_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TX90P_ANN_EXT_2050S_RCP85_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TXX_ANN_EXT_2050S_RCP26_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TSTD_DJF_VAR_2000S_S0_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TN10P_ANN_EXT_2050S_RCP85_VALUE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_JJA_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_JJA_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TX90P_ANN_EXT_2000S_S0_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_R10MM_ANN_EXT_2030S_RCP26_VALUE_MMS_GLOBAL": "R10mm (d)",
  "CC_TN10P_ANN_EXT_2030S_RCP26_CHANGE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP85_VALUE_MMS_GLOBAL": "rx1day(mm/d)",
  "CC_TSTD_JJA_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP85_VALUE_MME_GLOBAL": "RX5D (mm/d)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_R10MM_ANN_EXT_2050S_RCP85_CHANGE_MMS_GLOBAL": "R10mm (%)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_ANN_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "Tmean (℃）",
  "CC_TMEAN_DJF_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_JJA_VAR_2000S_S0_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP26_VALUE_MMS_GLOBAL": "rx1day(mm/day)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP85_VALUE_MMS_GLOBAL": "rx5day(mm/d)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP85_CHANGE_MMS_GLOBAL": "rx5day (%)",
  "CC_TSTD_DJF_VAR_2000S_S0_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_R10MM_ANN_EXT_2030S_RCP45_CHANGE_MMS_GLOBAL": "R10mm (%)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP26_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TX90P_ANN_EXT_2050S_RCP45_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "prcptot (%)",
  "CC_PRCPTOT_JJA_MEAN_2000_S0_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TSTD_JJA_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_ANN_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_DJF_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_TSTD_ANN_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_JJA_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_JJA_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TXX_ANN_EXT_2030S_RCP26_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "Tmean (℃）",
  "CC_TSTD_JJA_VAR_2000S_S0_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP45_VALUE_MMS_GLOBAL": "rx1day(mm)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP45_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_VAR_2000_S0_VALUE_MME_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_DJF_VAR_2000S_S0_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP45_VALUE_MMS_GLOBAL": "sfcWindmax(m/s)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TN10P_ANN_EXT_2050S_RCP45_CHANGE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TN10P_ANN_EXT_2050S_RCP45_VALUE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_JJA_VAR_2050S_RCP26_CHANGE_MMS_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP45_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_PRCPTOT_ANN_VAR_2030S_RCP85_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_SFCWIND_ANN_MEAN_2000S_S0_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP45_CHANGE_MME_GLOBAL": "rx1day (%)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_RX1DAY_ANN_EXT_2050S_RCP85_CHANGE_MME_GLOBAL": "rx1day (%)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_SFCWINDMAX_ANN_EXT_2050S_RCP85_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TXX_ANN_EXT_2030S_RCP45_VALUE_MMS_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_R10MM_ANN_EXT_2050S_RCP26_VALUE_MME_GLOBAL": "R10mm (d)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP85_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_MEAN_2050S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_RX1DAY_ANN_EXT_2000_S0_VALUE_MMS_GLOBAL": "rx1day (mm)",
  "CC_RX5DAY_ANN_EXT_2030S_RCP45_CHANGE_MMS_GLOBAL": "rx5day (%)",
  "CC_TX90P_ANN_EXT_2030S_RCP85_VALUE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TXX_ANN_EXT_2030S_RCP45_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TN10P_ANN_EXT_2030S_RCP45_CHANGE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TX90P_ANN_EXT_2050S_RCP26_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_R10MM_ANN_EXT_2030S_RCP45_VALUE_MMS_GLOBAL": "R10mm (d)",
  "CC_TN10P_ANN_EXT_2000S_S0_VALUE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP45_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_DJF_VAR_2050S_RCP26_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_DJF_MEAN_2000S_S0_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TN10P_ANN_EXT_2030S_RCP85_CHANGE_MMS_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP45_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TMEAN_ANN_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP45_VALUE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP26_VALUE_MME_GLOBAL": "RX5D (mm/d)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP26_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TMEAN_DJF_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_PRCPTOT_DJF_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TSTD_DJF_VAR_2050S_RCP85_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP85_CHANGE_MME_GLOBAL": "rx1day (%)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_DJF_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP45_CHANGE_MME_GLOBAL": "rx1day (%)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_SFCWINDMAX_ANN_EXT_2030S_RCP85_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_JJA_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_TMEAN_JJA_MEAN_2050S_RCP26_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TXX_ANN_EXT_2050S_RCP45_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TSTD_JJA_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP45_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_ANN_VAR_2050S_RCP45_VALUE_MME_GLOBAL": "Precipitation (mm)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP45_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_JJA_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TSTD_JJA_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TXX_ANN_EXT_2050S_RCP85_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TSTD_JJA_VAR_2030S_RCP26_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_DJF_MEAN_2050S_RCP26_VALUE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_PRCPTOT_JJA_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TN10P_ANN_EXT_2030S_RCP85_VALUE_MME_GLOBAL": "Percentage of days when Tmin < 10th percentile (%)  (%)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP85_VALUE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_SFCWIND_JJA_VAR_2050S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_R10MM_ANN_EXT_2050S_RCP26_CHANGE_MMS_GLOBAL": "R10mm (%)",
  "CC_SFCWIND_JJA_MEAN_2030S_RCP26_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_SFCWIND_JJA_MEAN_2050S_RCP85_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_TX90P_ANN_EXT_2050S_RCP85_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_SFCWIND_ANN_VAR_2030S_RCP26_CHANGE_MMS_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_DJF_VAR_2050S_RCP45_CHANGE_MME_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_ANN_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_TMEAN_JJA_MEAN_2030S_RCP26_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_JJA_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_SFCWIND_DJF_MEAN_2030S_RCP85_VALUE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TSTD_ANN_VAR_2050S_RCP45_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_PRCPTOT_DJF_VAR_2050S_RCP26_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_SFCWIND_DJF_VAR_2030S_RCP26_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP26_VALUE_MME_GLOBAL": "RX1D (mm/d)",
  "CC_TSTD_ANN_VAR_2050S_RCP85_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TMEAN_DJF_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TXX_ANN_EXT_2030S_RCP85_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%) (℃)",
  "CC_TSTD_JJA_VAR_2030S_RCP45_VALUE_MME_GLOBAL": "Tstd (℃)",
  "CC_R10MM_ANN_EXT_2030S_RCP26_CHANGE_MMS_GLOBAL": "R10mm (%)",
  "CC_PRCPTOT_ANN_MEAN_2030S_RCP85_CHANGE_MMS_GLOBAL": "prcptot (%)",
  "CC_RX5DAY_ANN_EXT_2050S_RCP26_CHANGE_MMS_GLOBAL": "rx5day (%)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP45_CHANGE_MME_GLOBAL": "sfcWind (m/s)",
  "CC_TX90P_ANN_EXT_2030S_RCP85_CHANGE_MME_GLOBAL": "Percentage of days when Tmax > 90th percentile (%)  (%)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP45_CHANGE_MMS_GLOBAL": "Tmean (℃）",
  "CC_TSTD_ANN_VAR_2030S_RCP45_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_R10MM_ANN_EXT_2050S_RCP85_VALUE_MMS_GLOBAL": "R10mm (d)",
  "CC_SFCWIND_ANN_MEAN_2030S_RCP45_VALUE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_SFCWIND_DJF_VAR_2050S_RCP26_CHANGE_MME_GLOBAL": "Wind Speed (m/s)",
  "CC_PRCPTOT_DJF_VAR_2030S_RCP85_VALUE_MMS_GLOBAL": "prcptot (mm)",
  "CC_RX1DAY_ANN_EXT_2030S_RCP45_VALUE_MME_GLOBAL": "RX1D (mm/d)",
  "CC_TSTD_ANN_VAR_2030S_RCP85_CHANGE_MMS_GLOBAL": "Tstd (℃)",
  "CC_TMEAN_ANN_MEAN_2050S_RCP85_CHANGE_MMS_GLOBAL": "Tmean (℃）"
}



// WEBPACK FOOTER //
// ./src/view/BSD/BSDConfigLegendTitle_CC.js